var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-content"},[_c('div',{staticClass:"customer-header"},[_c('h1',[_vm._v(_vm._s(_vm.$_('customer_list_of'))+" "+_vm._s(_vm.sCompany))])]),_c('div',{staticClass:"customer-list"},[_c('CustomerList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }